import { func } from 'prop-types';
import React from 'react';
import { Col, Input, Label, Row } from 'reactstrap';

import TagInput from '../../../generic/TagInput';
import { campaignProductMetaShape } from '../../../prop-types';
import { tapFlashError } from '../../../utils/flash';
import { collectionIdPrefix, contentIdPrefix } from '../../constants';
import { getProductMetaFieldName } from '../../utils';

function CollectionIds({ productMeta, onChange }) {
  const { productId, collectionIds, index, useCollectionIds, contentIds } =
    productMeta;

  const isValidCollectionId = collectionId => {
    if (collectionIdPrefix.test(collectionId)) {
      tapFlashError()(
        new Error(
          `The input ${collectionId} contains the prefix 'ern:collection:cnc:'. This prefix does not need to be added for collection IDs.`,
        ),
      );
      return false;
    }
    if (contentIdPrefix.test(collectionId)) {
      tapFlashError()(
        new Error(
          `The input ${collectionId} is a content ID. It should be added in the content IDs field and not in the collection IDs field.`,
        ),
      );
      return false;
    }
    return true;
  };

  const handleCollectionIdsChange = event => {
    const { value } = event.target;
    if (isValidCollectionId(value)) {
      if (productMeta && contentIds.length) {
        onChange({
          target: {
            name: getProductMetaFieldName(index, 'contentIds'),
            value: [],
          },
        });
      }
      onChange(event);
    }
  };

  return (
    <>
      <Row className="mt-3 align-items-center">
        <Col sm={3} />
        <Col sm={1}>
          <Label check>
            <Input
              type="checkbox"
              checked={useCollectionIds}
              name={getProductMetaFieldName(index, 'useCollectionIds')}
              onChange={onChange}
            />
            Use Collection Ids
          </Label>
        </Col>
        <Col sm={4} className="align-self-start">
          <TagInput
            id={`ca-collectionIds.${productId}`}
            name={getProductMetaFieldName(index, 'collectionIds')}
            value={collectionIds}
            onChange={handleCollectionIdsChange}
            allowCopy
            readOnly={!useCollectionIds}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={4} />
        <Col sm={4}>
          <Label className="c-campaign-line__label">Collection Ids</Label>
        </Col>
      </Row>
    </>
  );
}

CollectionIds.propTypes = {
  productMeta: campaignProductMetaShape.isRequired,
  onChange: func.isRequired,
};

export default CollectionIds;
